import { render, staticRenderFns } from "./ListBusinessDocuments.vue?vue&type=template&id=dbdef260&scoped=true&lang=pug&"
import script from "./ListBusinessDocuments.vue?vue&type=script&lang=js&"
export * from "./ListBusinessDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ListBusinessDocuments.vue?vue&type=style&index=0&id=dbdef260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdef260",
  null
  
)

export default component.exports